import { createSelector } from 'reselect'

import { selectStrategicInitiativesState } from './selectStrategicInitiativesState'

export const selectStrategicInitiativesIsLoading = createSelector(
  [selectStrategicInitiativesState],
  (state) => state.isLoading
)
